import * as actionTypes from '../../../actions/actionTypes';
import { updateObject } from '../../../utility.js';

const initialState = {
    settings: {},
    updated: false,
    error: false,
    loading: false,
    fetched: false
};

/* ------------------ Company Update ------------------- */
const settingsCompanyUpdateStart = ( state, action ) => {
    return updateObject( state, { loading: true, error: false, updated: false } );
};

const settingsCompanyUpdateReset = ( state, action ) => {
    return updateObject( state, { loading: false, error: false, updated: false } );
};

const settingsCompanyUpdateSuccess = ( state, action ) => {
    return updateObject( state, {
	    settings: action.settings,
        loading: false,
        error: false,
        updated: true
    } );
};

const settingsCompanyUpdateFail = ( state, action ) => {
    return updateObject( state, { loading: false, error: action.error } );
};

/* ------------------ Company Fetch ------------------- */
const settingsCompanyFetchStart = ( state, action ) => {
    return updateObject( state, { loading: true, error: false, fetched: false, settings: {} } );
};

const settingsCompanyFetchReset = ( state, action ) => {
    return updateObject( state, { loading: false, error: false, fetched: false, settings: {} } );
};

const settingsCompanyFetchSuccess = ( state, action ) => {
    return updateObject( state, {
        settings: action.settings,
        loading: false,
        error: false,
        fetched: true
    } );
};

const settingsCompanyFetchFail = ( state, action ) => {
    return updateObject( state, { loading: false, error: action.error } );
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
    	case actionTypes.SETTINGS_COMPANY_UPDATE_START: return settingsCompanyUpdateStart( state, action );
    	case actionTypes.SETTINGS_COMPANY_UPDATE_SUCCESS: return settingsCompanyUpdateSuccess( state, action );
    	case actionTypes.SETTINGS_COMPANY_UPDATE_FAIL: return settingsCompanyUpdateFail( state, action );
        case actionTypes.SETTINGS_COMPANY_UPDATE_RESET: return settingsCompanyUpdateReset( state, action );
        case actionTypes.SETTINGS_COMPANY_FETCH_START: return settingsCompanyFetchStart( state, action );
        case actionTypes.SETTINGS_COMPANY_FETCH_SUCCESS: return settingsCompanyFetchSuccess( state, action );
        case actionTypes.SETTINGS_COMPANY_FETCH_FAIL: return settingsCompanyFetchReset( state, action );
        case actionTypes.SETTINGS_COMPANY_FETCH_RESET: return settingsCompanyFetchFail( state, action );
        default: return state;
    }
};


export default reducer;


// WEBPACK FOOTER //
// ./src/_store/reducers/calculator/settings/company.js